import { readAllData, STORES } from "utility"
import { mergeUpsertOffline } from "./crud"

export async function getRemindersOffline({ page = 1, limit = 20 } = {}) {
  const reminders = await readAllData(STORES.REMINDERS)
  const sorted = reminders.sort(
    (a, b) => new Date(b.date || 0) - new Date(a.date || 0),
  )
  const totalItems = sorted.length
  const startIdx = (page - 1) * limit
  return { data: sorted.slice(startIdx, startIdx + limit), totalItems }
}

export async function createReminderOffline(body) {
  const tempId = crypto.randomUUID()
  const reminder = {
    ...body,
    id: tempId,
    createdAt: new Date().toISOString(),
    __offline: true,
  }
  await mergeUpsertOffline(STORES.REMINDERS, reminder, { markOffline: true })
  return reminder
}
